import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { CommonStyles } from '../styles/Styles';
import { MultiTextComponent } from './quizzing/MultiTextComponent';
import { ButtonComponent } from './quizzing/ButtonComponent';
import { TextComponent } from './quizzing/TextComponent';
import { dataItem } from '../data/data';
import { AppHelper } from '../helpers/AppHelper';
import { ValidationHelper } from '../common/helpers/ValidationHelper';
import { AppTheme } from '../styles/AppTheme';
import { AppConfig } from '../AppConfig';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Icon from '@material-ui/core/Icon';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Link } from 'react-router-dom';

export class ReferralComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      copied: false
    }
    this.referralData = dataItem.referralData
  }

  render() {
    return (
      <Dialog
        open={this.props.showDialog}
        onClose={this.props.closeDialog}
        scroll='paper'
        classes={{
          root: css(Styles.customRoot),
          paperWidthSm: css(Styles.dialog),
          scrollPaper: css(Styles.scrollPaper)
        }}
      >
        <DialogTitle className={css(Styles.dialogTitle)}>
          <div className={css(Styles.dialogTitleContainer)}>
            <p className={css(Styles.dialogTitleTxt)}>{this.referralData.title}</p>
            <div className={css(Styles.dialogTitleClose)}>
              <Icon
                onClick={() => this.props.closeDialog()}
                className={css(Styles.close)}>
                close
              </Icon>
            </div>
          </div>
        </DialogTitle>
        <DialogContent className={css(Styles.dialogContent)}>
          <p className={css(Styles.dialogContentData)}>
            {this.referralData.desc}
          </p>
          <p className={css(Styles.dialogContentData, Styles.extraTopMargin)}>
            {this.referralData.descExtra}
          </p>
          <div className={css(Styles.referralContainer)}>
            <div className={css(Styles.referralImgContainer)}>
              <img src={this.referralData.img} className={css(Styles.imgContainer)} />
            </div>
            <div className={css(Styles.referralDescContainer)}>
              <p className={css(Styles.dialogContentTitleData)}>{AppConfig.Title}</p>
              <p className={css(Styles.dialogContentData, Styles.dialogContentsubData)}>{this.referralData.subDesc}</p>
            </div>
          </div>
        </DialogContent>
        <DialogActions className={css(Styles.dialogActions)}>
          <p className={this.state.copied ? css(Styles.referralLink, Styles.bgColor) : css(Styles.referralLink)}>{AppHelper.createReferralLink()}</p>
          <CopyToClipboard
            onCopy={() => this.setState({copied: true})}
            text={AppHelper.createReferralLink()}>
            <Button
              variant='contained'
              className={css(Styles.buttonContainer)}
            >
              COPY
            </Button>
          </CopyToClipboard>
        </DialogActions>
      </Dialog>
    )
  }
}

const Styles = StyleSheet.create({
  imgContainer: {
    maxHeight: '100%',
    maxWidth: '100%'
  },
  dialog: {
    maxWidth: 800,
    borderRadius: 31,
    padding: '20px 30px',
    '@media (max-width: 767px)': {
      maxWidth: 'unset',
      margin: 20,
      padding: '15px 20px',
    },
  },
  dialogTitle: {
    padding: 0
  },
  dialogTitleContainer: {
    display: 'flex',
  },
  dialogTitleTxt: {
    color: AppTheme.primaryColor,
    margin: 0,
    fontSize: AppTheme.dialogTitleFontSize,
    fontWeight: 'normal',
    '@media (max-width: 767px)': {
      fontSize: AppTheme.dialogTitleFontSizeBelow767,
    }
  },
  dialogContent: {
    padding: 0,
    paddingTop: 10,
    paddingBottom: 20
  },
  dialogContentTitleData: {
    margin: 0,
    color: AppTheme.primaryColor,
    fontSize: 20,
    fontWeight: 'bold',
  },
  dialogContentData: {
    margin: 0,
    color: AppTheme.primaryColor,
    fontSize: AppTheme.dialogContentFontSize,
    whiteSpace: 'pre-wrap',
    '@media (max-width: 767px)': {
      fontSize: AppTheme.dialogContentFontSizeBelow767,
    }
  },
  dialogContentsubData: {
    marginTop: 10
  },
  referralContainer: {
    border: '1px solid' + AppTheme.primaryColor,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: 10
  },
  referralImgContainer: {
    width: 600,
    '@media (max-width: 767px)': {
      width: 'unset',
    }
  },
  referralDescContainer: {
    padding: 20,
    paddingTop: 0,
    '@media (max-width: 767px)': {
      padding: 10,
      paddingTop: 0,
    }
  },
  dialogActions: {
    padding: 0,
    display: 'flex',
    justifyContent: 'space-between',
    '@media (max-width: 767px)': {
      flexDirection: 'column'
    }
  },
  buttonContainer: {
    width: 150,
    fontSize: 17,
    borderRadius: 30,
    margin: 0,
    display: 'flex',
    fontWeight: 'normal',
    alignItems: 'center',
    backgroundColor: AppTheme.secondaryColor,
    color: AppTheme.secondaryBg,
    '@media (max-width: 767px)': {
      width: 100,
      fontSize: 13,
      borderRadius: 25,
    }
  },
  buttonContainerSecond: {
    maxWidth: 150,
    fontSize: 17,
    fontWeight: 'normal',
    borderRadius: 30,
    display: 'flex',
    alignItems: 'center',
    '@media (max-width: 767px)': {
      maxWidth: 100,
      fontSize: 13,
      borderRadius: 25,
      padding: '0px 10px',
    },
    backgroundColor: 'transparent',
    boxShadow: 'unset',
    color: AppTheme.tertiaryColor,
  },
  dialogTitleClose: {
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-end',
    alignItems: 'center',
    cursor: 'pointer',
  },
  close: {
    color: AppTheme.tertiaryColor,
    fontSize: 30,
    '@media (max-width: 767px)': {
      fontSize: 30,
    }
  },
  referralLink: {
    padding: 5,
    margin: 0,
    '@media (max-width: 767px)': {
      wordBreak: 'break-word',
      border: '1px solid lightgrey',
      marginBottom: 5,
      marginTop: 5,
    }
  },
  bgColor: {
    backgroundColor: 'lightgrey'
  },
  customRoot: {
    zIndex: 10000000000
  },
  extraTopMargin: {
    marginTop: 5
  }
})


// WEBPACK FOOTER //
// ./src/components/ReferralComponent.js